import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './TopHead.css';
import Loader from './Loader/Loader';


const TopHead = () => {
    // State to store fetched movies data
    const [movies, setMovies] = useState([]);
    // State to track the index of the currently displayed movie
    const [currentMovieIndex, setCurrentMovieIndex] = useState(0);
    

    // useEffect to fetch movie data when the component mounts
    useEffect(() => {
        const fetchMovies = async () => {
             // Fetch the TMDB API key from environment variables
             const apiKey = process.env.REACT_APP_TMDB_API_KEY;
            try {
                // Array of movie IDs to fetch movie data from
                const movieIds = [453395, 284053, 299534, 24428, 299536, 118340, 76170, 449176, 315635, 284054, 284052, 102899, 299537, 100402, 1726, 429617]; // Dr. Strange, Avengers movies
                
                // Create an array of fetch requests for each movie ID
                const requests = movieIds.map(id =>
                    fetch(`https://api.themoviedb.org/3/movie/${id}?api_key=${apiKey}`)
                        .then(response => {
                            // Check if the response is ok, otherwise throw an error
                            if (!response.ok) {
                                throw new Error('Failed to fetch movie data');
                            }
                            // Parse the response JSON
                            return response.json();
                        })
                );

                // Wait for all fetch requests to complete
                const moviesData = await Promise.all(requests);
                // Store the fetched movies data in the state
                setMovies(moviesData);
            } catch (error) {
                // Log any errors that occur during fetching
                console.error('Error fetching movies:', error);
            }
        };

        // Call the fetchMovies function to start fetching data
        fetchMovies();
    }, []);

    // useEffect to randomly select a movie index when the component mounts or movies change
    useEffect(() => {
        // Check if movies array has data
        if (movies.length > 0) {
            // Randomly select a movie index
            const randomIndex = Math.floor(Math.random() * movies.length);
            // Update the state with the randomly selected movie index
            setCurrentMovieIndex(randomIndex);
        }
    }, [movies]);

    // Check if movies data is still being fetched
    if (movies.length === 0) {
        // Display loading message while fetching data
        return <Loader />;
    }

    // Get the currently selected movie data
    const movie = movies[currentMovieIndex];

    // Calculate backdrop image style from random selection
    const backdropStyle = {
        backgroundImage: `url(https://image.tmdb.org/t/p/original${movie.backdrop_path})`,
    };

    // Format genres as a comma-separated string
    const genreList = movie.genres.map(genre => genre.name).join(', ');

    // Format release date
    const releaseDate = new Date(movie.release_date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });

    // Format runtime (in hours and minutes)
    const runtimeHours = Math.floor(movie.runtime / 60);
    const runtimeMinutes = movie.runtime % 60;
    const runtime = `${runtimeHours}h ${runtimeMinutes}min`;

    // Format user score as a percentage
    const userScore = `${movie.vote_average * 10}%`;

    return (
        // Top head container with backdrop image style
        <div className="top-head-containers" style={backdropStyle}>
            
            <div className="containers">
                <div className="row">
                    {/* Poster Image */}
                    <div className="col-md-3 col-12 mb-4">
                        <img 
                            src={`https://image.tmdb.org/t/p/w300${movie.poster_path}`} 
                            alt={movie.title} 
                            className="poster-image" 
                        />
                    </div>

                    {/* Movie Details */}
                    <div className="col-md-7 col-12 movie-details">
                        <h2>{movie.title}</h2>
                        <div className='p'><strong>Date:</strong> {releaseDate}</div>
                        <div className='p'><strong>Rating:</strong> {movie.adult ? 'R' : 'PG-13'}</div>
                        <div className='p'><strong>Genre:</strong> {genreList}</div>
                        <div className='p'><strong>Length:</strong> {runtime}</div>
                        <div className='p'><strong>User Score:</strong> {userScore}</div>
                        <div className='p'><strong>Description:</strong> {movie.overview}</div>
                        
                        {/* Link to Movie Details page with movie data passed in state */}
                        <Link 
                            to={{ pathname: `/movies/${movie.id}`, state: { movie: movie } }} 
                            className="btn-primary">
                            View Details
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TopHead;
